import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private http: HttpClient) { }


  submitSurvey(data) {
    const url = 'Authentication/gstat/SurveySubmitEfiling';
    return this.http.post<any>(url, data);

  }
  submitSurveyCIS(data) {
    // const url = 'Integration/gstat/SurveySubmit';
    const url = 'Authentication/gstat/SurveySubmitCis';
    return this.http.post<any>(url, data);

  }

  submitFeedback(data){
    //  const url = 'Survey/gstat/SurveySubmit';
     const url = 'Authentication/grp/UpdateReopenTicket';
    return this.http.put<any>(url, data);
  }




}
